export type ResponseLogin = {
    status: number,
    message: string,
    data?: ResponseLoginData,
    token?: string
}

export type ResponseLoginData = {
    fullname: string,
    phone: string,
    email: string,
    address: string,
    photo: string,
    phone_verif: boolean,
    code_county: string,
    name_county: string,
    fcm_token: string,
    active_status: boolean,
    created_at: string,
    updated_at: string
}

export const defaultLoginData: ResponseLoginData = {
    fullname: "",
    phone: "",
    email: "",
    address: "",
    photo: "",
    phone_verif: false,
    code_county: "",
    name_county: "",
    fcm_token: "",
    active_status: false,
    created_at: "",
    updated_at: ""
}